<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit, invalid }" slim>
    <form
      class="auth-form"
      @submit.prevent="handleSubmit(handleForgotPassword)"
    >
      <!--login-->
      <div
        v-if="['B', 'C'].includes(layout) && menu === 'button'"
        class="mb-4 text-center"
      >
        <span class="me-2">{{
          $t('component.ForgotPasswordModal.login')
        }}</span>
        <a
          href="#"
          class="text-decoration-underline auth-form-link"
          @click.prevent="$emit('switchCategory', 'login')"
        >
          {{ $t('component.AuthModal.list.login') }}</a
        >
      </div>

      <div class="mb-4">
        <label class="form-label required">{{
          $t('common.profile.username')
        }}</label>
        <ValidationProvider
          ref="fpUsernameRef"
          v-slot="{ valid, invalid, dirty }"
          vid="fpUsername"
          :name="$t('common.profile.username')"
          rules="required"
          slim
        >
          <input
            :key="'smsForm.fpUsername'"
            v-model="fpUsername"
            :class="{
              'is-valid': valid,
              'is-invalid': dirty && invalid
            }"
            :placeholder="
              $t('component.ForgotPasswordModal.fpUsername.placeholder')
            "
            name="fpUsername"
            type="text"
            class="form-control"
            autofocus
          />
        </ValidationProvider>
      </div>

      <div class="mb-4">
        <label class="form-label required">{{
          $t('common.profile.tel')
        }}</label>
        <IntelInput
          v-model="fpTel"
          :country-list="intelCountries"
          :placeholder="$t('common.profile.tel')"
          @validate="isValid => (isFpCountryCodeValid = isValid)"
        ></IntelInput>
      </div>

      <div class="mb-4">
        <label class="form-label required">{{ $t('common.imageCode') }}</label>
        <div class="d-flex gap-3 align-items-center">
          <ValidationProvider
            ref="imageCodeRef"
            v-slot="{ valid, invalid, dirty }"
            vid="imageCode"
            :name="$t('common.imageCode')"
            rules="required"
            slim
          >
            <input
              :key="'smsForm.imageCode'"
              v-model="imageCode"
              :class="{
                'is-valid': valid,
                'is-invalid': dirty && invalid
              }"
              :placeholder="
                $t('component.ForgotPasswordModal.imageCode.placeholder')
              "
              name="imageCode"
              type="text"
              class="form-control"
              autocomplete="off"
            />
          </ValidationProvider>
          <div class="verify-code-pic">
            <img
              v-if="imageSrc !== null"
              :src="'data:image/jpeg;base64, ' + imageSrc"
              alt="image-code"
            />
            <i v-if="imageSrc === null" class="km-icon-spinner" />
          </div>
          <i
            class="km-icon-arrow-rotate auth-form-link verify-code-update-icon"
            @click.prevent="refreshImageSrc"
          />
        </div>
      </div>

      <div class="mb-4">
        <button
          :key="'smsForm.submit'"
          :disabled="invalid || !isFpCountryCodeValid"
          type="submit"
          class="btn rounded-pill d-block w-100"
          :class="customBtnPrimaryClass"
        >
          {{ $t('common.submit') }}
        </button>
      </div>

      <!--login-->
      <div v-if="menu === 'tabs'" class="text-center">
        <span class="me-2">{{
          $t('component.ForgotPasswordModal.login')
        }}</span>
        <a
          href="#"
          class="text-decoration-underline auth-form-link"
          @click.prevent="$emit('switchCategory', 'login')"
        >
          {{ $t('component.AuthModal.list.login') }}</a
        >
      </div>

      <div class="divider my-4">or</div>
      <div class="d-grid gap-4">
        <template v-for="btn in buttons">
          <button
            v-if="btn.enable"
            :key="btn.category"
            class="btn btn-outline-gray"
            @click.prevent="btn.method()"
          >
            {{ btn.title }}
          </button>
        </template>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api'
import useForgotPassword from '../composables/useForgotPassword'
import IntelInput from './IntelInput.vue'

export default defineComponent({
  components: { IntelInput },
  props: {
    layout: {
      type: String,
      default: 'A'
    },
    menu: {
      type: String,
      default: 'tabs'
    },
    buttons: {
      type: Array,
      default: () => []
    },
    intelCountries: {
      type: Array,
      default: () => []
    },
    // custom class
    customBtnPrimaryClass: {
      type: String,
      default: 'btn-primary'
    }
  },
  setup(props, context) {
    const {
      fpUsername,
      fpTel,
      imageCode,
      imageSrc,
      refreshImageSrc,
      forgotPassword,
      refreshData
    } = useForgotPassword(context)

    const isFpCountryCodeValid = ref(false)

    onMounted(() => {
      refreshData()
    })

    function handleForgotPassword() {
      forgotPassword(() => {
        context.emit('switchCategory', 'login')
      })
    }

    return {
      fpUsername,
      fpTel,
      imageCode,
      imageSrc,
      isFpCountryCodeValid,

      refreshImageSrc,
      handleForgotPassword
    }
  }
})
</script>
